var chunkToChildrenMap = {
	"9876": [
		6261,
		3590,
		4034,
		3225,
		7988,
		1994,
		5589,
		1905,
		8047,
		3524,
		9532,
		8268,
		1925
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));